import { useState } from "react";
import { toast } from "react-hot-toast";
import { insertHotel } from "@repo/api-client";
import type { InsertHotelRequest } from "@repo/types";


const initialHotelState: InsertHotelRequest = {
  SalesmanCode: "",
  HotelName: "",
  Address: "",
  City: "",
  State: "",
  Country: "",
  PostalCode: 0,
  Phone: "",
  Email: "",
  Username: "",
  Password: "",
  Website: "",
  TaxNumber: "",
  CheckInTime: "",
  CheckOutTime: "",
  GST: 0,
  FoodGST: 0,
  ServiceCharge: 0,
  LicenceKey: "",
  ProExpireDate: "",
  LogoUrl: "",
  CurrencySymbol: "₹",
};

export const useHotelInsertion = () => {
  const [hotelRequest, setHotelRequest] =
    useState<InsertHotelRequest>(initialHotelState);

  const [loading, setLoading] = useState(false);

  const resetForm = () => {
    setHotelRequest(initialHotelState);
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      const response = await insertHotel(hotelRequest);
      if (response.Success) {
        toast.success(response.Message || "Hotel inserted successfully!");
        resetForm();
      } else {
        toast.error(response.Message || "Failed to insert hotel!");
      }
    } catch (error: any) {
      toast.error("Something went wrong while inserting hotel!");
    } finally {
      setLoading(false);
    }
  };

  return {
    hotelRequest,
    setHotelRequest,
    handleSave,
    loading,
    resetForm,
  };
};
